import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Accordion from '../../Accordion';
import Download from '../../../Download';
import { Load } from '../../../Error';
import Loading from '../../../../General/Loading';
import Text from '../../../../General/Text';

import {
  ContentContainer,
  Divider,
  LoadingWrapper,
} from './styles/ContentStyled';

import { DueDateText } from '../../styles/CurrentInvoiceStyled';

import { Dates, Numbers } from '../../../../../helpers';

import InvoicesServices from '../../../../../services/Invoices';

const Content = ({ currentData }) => {
  const [data, setData] = useState({});
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const loadData = () => {
    InvoicesServices.getInvoiceById(currentData.lastInvoice.documentId)
      .then(res => {
        const { categories, pdf } = res[0];
        setData(categories);
        setPdfUrl(pdf);
      })
      .catch(() => {
        setError(true);
      })
      .then(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    loadData();
  }, []);

  return (
    <ContentContainer
      key="content"
      initial="collapsed"
      animate="open"
      exit="collapsed"
      variants={{
        open: { opacity: 1, height: 'auto' },
        collapsed: { opacity: 0, height: 0 },
      }}
      transition={{ duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }}
    >
      <Divider />
      {loading ? (
        <LoadingWrapper>
          <Loading />
        </LoadingWrapper>
      ) : (
        <>
          {error && <Load onClick={loadData} />}
          {!error && (
            <>
              <Accordion
                data={data}
                dueDate={currentData.lastInvoice.dueDate}
              />
              <div style={{ width: '100%' }}>
                <Text
                  text={`Total a pagar: $${Numbers.addThousandSeparators(
                    currentData.lastInvoice.amountToPay
                  )}`}
                  color="#2d1441"
                  size="16px"
                  weight="500"
                  margin="0 0 20px 0"
                  align="right"
                />
              </div>
              <Download text="VER BOLETA" link={pdfUrl} />
              <DueDateText>
                {`Vencimiento: ${Dates.formatDateReadable(
                  currentData.lastInvoice.dueDate
                )}`}
              </DueDateText>
            </>
          )}
        </>
      )}
    </ContentContainer>
  );
};

Content.propTypes = {
  currentData: PropTypes.instanceOf(Object).isRequired,
};

export default Content;
